import profile from './profile.json';

export default {
  profile: {
    ...profile,
  },
};
